import React from 'react'
import PageContainer from '../components/PageContainer'
import { useTranslation } from 'react-i18next';

function DownloadTutorial() {
    const { t } = useTranslation();
    return (
        <PageContainer items="center">
            <h3 className="text-[#225424] text-center">{t("DownloadApp.add")} <span className="font-signature text-2xl text-[#b05704]">TicinoWild</span> {t("DownloadApp.toHome")}</h3>
            <div className='mt-8 flex flex-col md:flex-row items-center gap-8'>
                <video width="360" height="640" controls className='rounded-xl' poster='/videos/posters/safari-poster.jpg'>
                    <source src="/videos/safari-download-app.mp4" type="video/mp4" />
                    {t("DownloadApp.browserNotSupported")}
                </video>
                <video width="360" height="640" controls className='rounded-xl' poster='/videos/posters/chrome-poster.jpg'>
                    <source src="/videos/chrome-download-app.mp4" type="video/mp4" />
                    {t("DownloadApp.browserNotSupported")}
                </video>
            </div>

        </PageContainer>
    )
}

export default DownloadTutorial